import { render } from "./TranslationMenu.vue?vue&type=template&id=1e2fe5cc&scoped=true"
import script from "./TranslationMenu.vue?vue&type=script&lang=js"
export * from "./TranslationMenu.vue?vue&type=script&lang=js"

import "./TranslationMenu.vue?vue&type=style&index=0&id=1e2fe5cc&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2fe5cc"]])

export default __exports__